import { Button, Stack } from "@mui/material";

import { useCarrierShipmentPageContext, useDisclosure } from "hooks";
import { formatQuotingUnitOfMeasure } from "utils/quotes";

import { BookNowConfirmationModal } from "../BookNowConfirmationModal";

interface Props {
  shipment: CondensedShipment | undefined;
}

export function BookNowButton(props: Props) {
  const { shipment } = props;
  const {
    isOpen: bookNowOpen,
    onClose: onCloseBookNow,
    onOpen: onOpenBookNow,
  } = useDisclosure(false);
  const { onRefresh } = useCarrierShipmentPageContext();

  if (shipment === undefined || shipment.shipment_status === "BOOKED") {
    return null;
  }
  return (
    <Stack direction="row" spacing="1" sx={{ mt: "1rem" }}>
      <BookNowConfirmationModal
        shipment={shipment}
        visible={bookNowOpen}
        onClose={onCloseBookNow}
        onBook={() => {
          if (onRefresh) {
            onRefresh();
            // hack to refetch shipment and not re-render the book now button  after a booking.
            setTimeout(onRefresh, 3000);
          }
        }}
      />
      <Button onClick={onOpenBookNow} variant="contained" color="success">
        {`BOOK NOW $${shipment.book_now_info.book_now_price} ${shipment.book_now_info.book_now_currency}`}{" "}
        {shipment.info.quoting_unit_of_measure !== "ALL_IN"
          ? formatQuotingUnitOfMeasure(
              shipment.info.quoting_unit_of_measure,
              false,
            )
          : ""}
      </Button>
    </Stack>
  );
}
